




import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  name: "GGLink",
  props: {
    to: {
      type: String as PropType<string>,
      default: () => "#",
    },
    title: {
      type: String as PropType<string | null>,
      default: null,
    },
  },
  methods: {
    onClick() {
      alert(`Кликнули на ссылку с УРЛ ${this.to} и title ${this.title}`);
    },
  },
});
